import styled from 'styled-components'

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
`
